const dev = {
  ga_analytics: 'G-T7R4LQFE5G',
  s3: {
    BUCKET: "files.labs.pizarrovial.cl"
  },
  apiGateway: {
    URL: "https://api.labs.pizarrovial.cl"
  }
};

const prod = {
  ga_analytics: 'G-T7R4LQFE5G',
  s3: {
    BUCKET: "files.pizarrovial.cl"
  },
  apiGateway: {
    URL: "https://api.pizarrovial.cl"
  }
};

const config = process.env.REACT_APP_ENV === 'production'
  ? prod
  : dev;

export default {
  MAX_ATTACHMENT_SIZE: 5000000,
  ...config
};

console.log("ENV:" + process.env.REACT_APP_ENV);



// WEBPACK FOOTER //
// ./src/config.js